module.exports = __webpack_public_path__ + "6eac9408096fc7c40a6e57d16b81a34a.png";